// downloadFile fetches an export from the API and saves it through a
// temporary object URL. The export endpoints live on the API's own origin
// (not the PWA's), so a plain <a href> can't be trusted to carry the session
// cookie the way a same-origin link would: fetching it ourselves with
// credentials does. The filename comes from the response's
// Content-Disposition header when the server set one, otherwise the
// caller's fallback.
export async function downloadFile(url: string, fallbackFilename: string): Promise<void> {
  const res = await fetch(url, { credentials: 'include' })
  if (!res.ok) {
    throw new Error(`download failed: ${res.status}`)
  }
  const blob = await res.blob()
  const disposition = res.headers.get('Content-Disposition') ?? ''
  const match = /filename="?([^";]+)"?/.exec(disposition)
  const filename = match ? match[1] : fallbackFilename

  const objectUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  // Revoked after a tick, not immediately: iOS WebKit can cancel the download
  // if the object URL disappears before it has started reading the blob.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
}
